import React from 'react'

const LeftArrowIcon = () => {
    return (
        <div>
            <svg width="183" height="22" viewBox="0 0 183 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M181.001 13C182.105 13 183.001 12.1046 183.001 11C183.001 9.89543 182.105 9 181.001 9V13ZM20.3105 2.11966C20.3105 1.01509 18.9577 0.234043 18.0011 0.786328L2.61995 9.66667C1.66336 10.219 1.66336 11.781 2.61995 12.3333L18.0011 21.2137C18.9577 21.766 20.3105 20.9849 20.3105 19.8803V2.11966ZM181.001 9H18.3105V13H181.001V9Z" fill="#B1B1B1" />
            </svg>

        </div>
    )
}

export default LeftArrowIcon
